<div class="layout-online-eval">
  <app-online-evaluation-header [sellerDetails]="sellerDetails" *ngIf="!isHideHeader()"></app-online-evaluation-header>

  <div class="outlet-container">
    <router-outlet></router-outlet>
  </div>
  <div class="footer">
    <div>
      <span>© {{currentYear}} Auto Arremate.</span>
      <span>Todos os Direitos Reservados. <a (click)="openTermsConditionsModal()">Termos e
          condições de uso</a>.</span>
    </div>
  </div>

</div>